import React from 'react';
import {
    Card, CardContent, Typography, Box, Select,
    MenuItem, FormControl, InputLabel, Chip
} from '@mui/material';
import { Storage } from '../Types/Storage';

interface StorageSelectorProps {
    storages: Storage[];
    selectedStorageId: string | null;
    onStorageChange: (storageId: string) => void;
}

const StorageSelector: React.FC<StorageSelectorProps> = ({
    storages,
    selectedStorageId,
    onStorageChange
}) => {


    return (
        <Card>
            <CardContent>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Storage Selection
                </Typography>

                <FormControl fullWidth>
                    <InputLabel>Select Storage Facility</InputLabel>
                    <Select
                        value={selectedStorageId || ''}
                        label="Select Storage Facility"
                        onChange={(e) => onStorageChange(e.target.value)}
                    >
                        {storages.map((storage) => (
                            <MenuItem key={storage.id} value={storage.id}>
                                <Box display="flex" alignItems="center" gap={1} width="100%">
                                    <Box flex={1}>
                                        <Typography variant="body1" fontWeight="bold">
                                            {storage.name}
                                        </Typography>
                                    </Box>
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </CardContent>
        </Card>
    );
};

export default StorageSelector;
